// extracted by mini-css-extract-plugin
export default {"menuContainer":"RecordMenu_menuContainer__V8MDg","menuItem":"RecordMenu_menuItem__EvoEd"};